export default __webpack_public_path__ + "static/experienceImg4-fe4fe1d0c1e5db34a19cd41ec7952476.webp";